export const FETCH_CATEGORIES = 'FETCH_CATEGORIES'
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS'
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE'
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY'

export const FETCH_TAGS = 'FETCH_TAGS'
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS'
export const FETCH_TAGS_FAILURE = 'FETCH_TAGS_FAILURE'

export const FETCH_COST_TAGS_SUCCESS = 'FETCH_COST_TAGS_SUCCESS'
export const FETCH_TOPIC_TAGS_SUCCESS = 'FETCH_TOPIC_TAGS_SUCCESS'
export const FETCH_AUDIENCE_TAGS_SUCCESS = 'FETCH_AUDIENCE_TAGS_SUCCESS'
export const FETCH_FORMAT_TAGS_SUCCESS = 'FETCH_FORMAT_TAGS_SUCCESS'

export const FETCH_RESOURCES = 'FETCH_RESOURCES'
export const FETCH_RESOURCES_SUCCESS = 'FETCH_RESOURCES_SUCCESS'
export const FETCH_RESOURCES_FAILURE = 'FETCH_RESOURCES_FAILURE'

export const FETCH_MORE_RESOURCES = 'FETCH_MORE_RESOURCES'
export const FETCH_MORE_SUCCESS = 'FETCH_MORE_SUCCESS'
export const ALL_RESOURCES_FETCHED = 'ALL_RESOURCES_FETCHED'

export const POST_RESOURCE = 'POST_RESOURCE'
export const POST_RESOURCE_SUCCESS = 'POST_RESOURCE_SUCCESS'
export const POST_RESOURCE_FAILURE = 'POST_RESOURCE_FAILURE'

export const UPDATE_RESOURCE = 'UPDATE_RESOURCE'
export const UPDATE_RESOURCE_SUCCESS = 'UPDATE_RESOURCE_SUCCESS'
export const UPDATE_RESOURCE_FAILURE = 'UPDATE_RESOURCE_FAILURE'

export const DELETE_RESOURCE = 'DELETE_RESOURCE'
export const DELETE_RESOURCE_SUCCESS = 'DELETE_RESOURCE_SUCCESS'
export const DELETE_RESOURCE_FAILURE = 'DELETE_RESOURCE_FAILURE'

export const FETCH_LOCATIONS = 'FETCH_LOCATIONS'
export const FETCH_LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS'
export const FETCH_LOCATIONS_FAILURE = 'FETCH_LOCATIONS_FAILURE'

export const LOGIN_USER = 'LOGIN_USER'
export const SET_USER = 'SET_USER'
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE'
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS'

export const SET_TAGS = 'SET_TAGS'
export const SET_LOCATION = 'SET_LOCATION'

export const PAGE_SIZE = 20
